// extracted by mini-css-extract-plugin
module.exports = {"container":"SettingsScreen_container__1MEp1","menuIcon":"SettingsScreen_menuIcon__VyXSq","saveButtonPosition":"SettingsScreen_saveButtonPosition__3jK2S"};